import React from "react";
import Navbar from "./global-components/navbar-v2";
import PageHeader from "./global-components/page-header";
import Service from "./section-components/service-v5";
import Cta from "./section-components/cta-v10";
import FaqV2 from "./section-components/faq-v2";
import Testimonial from "./section-components/testimonial-v2";
import Brand from "./section-components/brand-v4";
import Case from "./section-components/case";
import Footer from "./global-components/footer-v2";

const ServiceV1 = () => {
  let ServiceObject = {
    serviceHeading:
      "We specialize in creating exceptional websites that seamlessly blend captivating design with flawless functionality. Our comprehensive website design and development services are tailored to your unique business needs. With our expertise, you can establish a strong online presence, leave a lasting impression, and build trust with your audience. Our user-friendly interfaces, lightning-fast loading times, and intuitive navigation enhance the overall user experience, leading to increased conversions and customer satisfaction. Let us take care of every aspect of your website, from design and development to content creation and search engine optimization, while you focus on growing your business successfully.",
    servicePointsLoop: [
      "Captivating design and flawless functionality.",
      "Tailored website solutions for unique business needs.",
      "Establish a strong online presence and build trust.",
      "Enhanced user experience for increased conversions.",
    ],
    serviceDiv: [
      {
        heading: "Website Design",
        description: "Drive Traction, Achieve Sustainable Growth.",
      },
      {
        heading: "Website Development",
        description:
          "Build fully functional and responsive websites optimized for performance and user experience.",
      },
      {
        heading: "Content Creation",
        description: "Develop compelling and engaging content that resonates with your target audience.",
      },
      {
        heading: "Search Engine Optimization (SEO)",
        description:
          "Improve website visibility and rankings on search engines to drive organic traffic and attract potential customers.",
      },
    ],
  };
  let workWithUs =
    "Partner with us to transform your online presence. Our team of experts will craft a website that not only looks stunning but also functions flawlessly, ensuring a memorable user experience. With tailored website solutions, captivating content creation, and strategic SEO techniques, we'll help you establish a strong online presence, attract your target audience, and boost conversions. Leave the technicalities to us while you focus on growing your business and achieving your goals.";

  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Website Design & Development" />
      <Service serviceDetail={ServiceObject} />
      <Cta workWithUs={workWithUs} />
      <FaqV2 />
      <Testimonial />
      <Brand />
      <Case customclass="case-one case-one__team-page case-one__service-page" />
      <Footer />
    </div>
  );
};

export default ServiceV1;
